import { render, staticRenderFns } from "./Tax-Status.vue?vue&type=template&id=0c592834"
import script from "./Tax-Status.vue?vue&type=script&lang=js"
export * from "./Tax-Status.vue?vue&type=script&lang=js"
import style0 from "./Tax-Status.vue?vue&type=style&index=0&id=0c592834&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports